<ng-container>
  <div class="page-title">
    <div [innerHTML]="'EmploymentInfo.First.Title' | translate | safe:'html'" class="title"></div>
    <div [innerHTML]="'EmploymentInfo.First.SubTitle' | translate | safe:'html'" class="sub-title"></div>
  </div>

  <app-employment
    (employmentModelChange)="updateUser()"
    [employmentModel]="user.employmentModel">
  </app-employment>
</ng-container>

<ng-container>
  <div *ngIf="isEmployed()" class="page-title">
    <div [innerHTML]="'EmploymentInfo.First.CitizenshipTitle' | translate | safe:'html'" class="title"></div>
    <!--    <div class="sub-title" [innerHTML]="'EmploymentInfo.First.CitizenshipSubTitle' | translate | safe:'html'"></div>-->
  </div>

  <app-employment-citizenship
    (employmentModelChange)="updateUser()"
    [addressModel]="user.addressModel"
    [employmentModel]="user.employmentModel">
  </app-employment-citizenship>
</ng-container>
